/* =============================================
   UNKNOWN DELIVERY — THEME JS
   ============================================= */

(function () {
  'use strict';

  /* ------------------------------------------
     AGE GATE
  ------------------------------------------ */
  const AGE_GATE_KEY = 'ud_age_verified';

  function initAgeGate() {
    const overlay = document.getElementById('age-gate-overlay');
    if (!overlay) return;

    const confirmBtn = document.getElementById('age-gate-confirm');
    const denyBtn = document.getElementById('age-gate-deny');

    // Check if current page/collection is adult-flagged
    const isAdultPage = document.body.classList.contains('adult-page');
    if (!isAdultPage) return;

    const verified = sessionStorage.getItem(AGE_GATE_KEY);
    if (!verified) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        sessionStorage.setItem(AGE_GATE_KEY, '1');
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    if (denyBtn) {
      denyBtn.addEventListener('click', function () {
        window.location.href = '/';
      });
    }
  }

  /* ------------------------------------------
     MEGA MENU — keyboard + touch support
  ------------------------------------------ */
  function initMegaMenu() {
    const navItems = document.querySelectorAll('.nav-item');

    navItems.forEach(function (item) {
      const panel = item.querySelector('.mega-panel');
      if (!panel) return;

      let leaveTimer;

      item.addEventListener('mouseenter', function () {
        clearTimeout(leaveTimer);
        panel.style.display = 'block';
        panel.style.animation = 'megaFadeIn 0.2s ease forwards';
      });

      item.addEventListener('mouseleave', function () {
        leaveTimer = setTimeout(function () {
          panel.style.display = 'none';
        }, 150);
      });

      panel.addEventListener('mouseenter', function () { clearTimeout(leaveTimer); });
      panel.addEventListener('mouseleave', function () {
        leaveTimer = setTimeout(function () {
          panel.style.display = 'none';
        }, 150);
      });
    });
  }

  /* ------------------------------------------
     MOBILE MENU TOGGLE
  ------------------------------------------ */
  function initMobileMenu() {
    const toggle = document.getElementById('mobile-menu-toggle');
    const mobileNav = document.getElementById('mobile-nav');
    if (!toggle || !mobileNav) return;

    const overlay = document.getElementById('mobile-nav-overlay');
    const closeBtn = mobileNav.querySelector('.mobile-nav-close');

    function openNav() {
      mobileNav.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.classList.add('mobile-nav-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      mobileNav.setAttribute('aria-hidden', 'false');
      if (closeBtn) closeBtn.focus();
    }

    function closeNav() {
      mobileNav.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.classList.remove('mobile-nav-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      mobileNav.setAttribute('aria-hidden', 'true');
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (mobileNav.classList.contains('open')) {
        closeNav();
      } else {
        openNav();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeNav();
      });
    }

    if (overlay) overlay.addEventListener('click', closeNav);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) {
        closeNav();
        toggle.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 900 && mobileNav.classList.contains('open')) closeNav();
    });

    // Accordion items in mobile nav
    const mobileItems = mobileNav.querySelectorAll('button.mobile-nav-trigger');
    mobileItems.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const sub = this.nextElementSibling;
        if (!sub || !sub.classList.contains('mobile-sub')) return;
        const isOpen = sub.classList.contains('open');
        mobileNav.querySelectorAll('.mobile-sub').forEach(function (s) { s.classList.remove('open'); });
        mobileNav.querySelectorAll('button.mobile-nav-trigger').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        if (!isOpen) {
          sub.classList.add('open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ------------------------------------------
     CART DRAWER / AJAX CART
  ------------------------------------------ */
  function initCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var counts = document.querySelectorAll('.cart-count');
        counts.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ------------------------------------------
     STICKY HEADER SHADOW
  ------------------------------------------ */
  function initStickyHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 4px 30px rgba(226,178,255,0.1)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  /* ------------------------------------------
     INIT
  ------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function () {
    initAgeGate();
    initMegaMenu();
    initMobileMenu();
    initCartCount();
    initStickyHeader();
  });
})();
